module.exports = __webpack_public_path__ + "42f7aa40c571b7ccf3da3ca823883906.MP3";